import React, { useContext, useEffect, useState } from "react";
// import './Integration.css';
import styled from "styled-components";
import { XbeContext } from "./../CardsPage";
import { withRouter } from "react-router-dom";
import { Login } from './Login';

function Integration1(props) {
  const context = useContext(XbeContext);
  // onClick={()=>props['history'].push(`?filters=${context["filters"].toString()}`)}


  const {
    step = 0,

    language = "en",

    appearance = "l",
    utm,
    id = 2051,
    salesCardId = 8,
    imageUrl,
    badgeText,
    title,
    description,
    learnMoreUrl,
    integrationTimeText,
    callToAction = 'Get started',
    proposalText,
    postponed,
    project_id,
    project_name,


  } = {...props}



  useEffect(() => {
    if (context && context['salesCards'].length) {

      let cardData = context['salesCards'].filter(one=>one['fields']['salesCardId'] === props['salesCardId'])[0];
      if (cardData) {

        const {

          language = "en",

          appearance = "l",
          utm,
          id = 2051,
          salesCardId = 8,
          imageUrl,
          badgeText,
          title,
          description,
          learnMoreUrl,
          integrationTimeText,
          callToAction = 'Get started',
          proposalText,
          postponed,
          project_id,
          project_name,


        } = {...cardData['fields']}



      }


    }
  }, [context])



  const {
    filters
  } = {...context}


  const [pa, setPa] = useState(step)


  const [login, setLogin] = useState()

  const [pa2, setPa2] = useState(pa)

  useEffect(() => {
    if (pa !== pa2 && !pa2) {
      setTimeout(() => {
        setPa2(pa)
      }, 200);
    } else {
      setPa2(pa)
    }
  }, [pa])

  return (
    <CssInt0>
      <div className="in00">
        <section className="int0">
          <div className="int_b_left">
            <div className="p_modal_b p_modal_b--left">
              <div className="p_x_solutions_grid">
                <div className="p_x_solleft">
                  <div className="p_x_solright_item">
                    <div className="l_flex l_flex--int">
                      <div href="#" className="int_close" onClick={()=>props['history'].push(`/?filters=${context['filters'].toString()}`)}>
                        ✕
                      </div>
                      <div className="p_x_card_z" />



                      <div className={`xbe_card xbe_card--int`}
                        onClick={(e)=>{
                          e.stopPropagation();
                          setPa();
                          setLogin();
                        }}
                      >
                        <div className="xbe_card_pic0">
                          <div className="xbe_card_pic">
                            <div className="xbe_card_pic_abs"
                              style={{
                                width: '100%',
                                backgroundImage: `url(${imageUrl})`
                              }}
                            />
                            <div className="xbe_card_pic_grad" />
                          </div>
                        </div>


                        <div className="xbe_card_flex">
                          <div className="xbe_card_content">

                            <div className="xbe_card_line">

                            <div className="xbe_card_badge0">
                              {badgeText}
                            </div>

                              <div className="xbe_card_title">
                                <div className="xbe_card_title">

                                {title}

                                </div>
                              </div>
                            </div>
                            <div className="xbe_card_line">
                              <div className="xbe_card_desc">

                                {description}

                              </div>
                            </div>
                          </div>



                          {Boolean(pa) && <div className="xbe_card_line"
                            onClick={(e)=>{
                              e.stopPropagation();
                              setPa();
                              setLogin();
                              }
                            }
                          >
                            <div className="xbe_card_ctan0">
                              <a href="#" className="x_link w-inline-block">
                                <span className="p_x_learnmore">
                                  Learn more
                                </span>
                              </a>
                            </div>
                          </div>}

                          {!pa && <div className="xbe_card_line"
                            onClick={(e)=>{
                              e.stopPropagation();
                              // setPa(1)
                              setLogin(true)
                            }
                            }
                          >
                            <div className="xbe_card_ctan0">
                              <a href="#" className="x_link w-inline-block">
                                <div className="xbe_card_button">

                                  {callToAction}

                                </div>
                              </a>
                            </div>
                          </div>}





                        </div>
                      </div>







                      <div className="p_modal_c p_modal_c--bot">
                        <div className="p_formgroup_lg p_formgroup_lg--grow">
                          <div className="p_modal_c">
                            <div className="x_flex">
                              <h4 className="p_int_h2">Integration steps</h4>
                            </div>
                          </div>

                          <div
                            onClick={()=> {
                              setPa()
                              setLogin(true)
                            }}
                            className={`p_modal_c p_todo_item ${login ? 'p_todo_item--active' : 'p_modal_todo_icon--def'}`}>
                              <div className="x_flex">
                              {!login && <div className="p_modal_todo_icon p_modal_todo_icon--def" />}
                              {login && <div className="p_modal_todo_icon p_modal_todo_icon--active"
                                style={{marginTop: 3,marginBottom: 2, position: 'relative'}}
                              />}
                                <div className="">
                                  <div className="p_modal_todo_name">
                                    Create an account
                                  </div>
                                  {/* {!Boolean(pa) && login && <div className="p_modal_todo_desctiption">
                                    Start your journey with Xsolla
                                  </div>} */}
                                </div>
                              </div>
                          </div>


                          <div
                            onClick={()=>{
                              setPa(2);
                              setLogin();
                            }}
                            className={`p_modal_c p_todo_item ${Boolean(pa) && parseInt(pa) === 2 ? 'p_todo_item--active' : 'p_modal_todo_icon--def'}`}>
                              <div className="x_flex">
                              {(!Boolean(pa) || parseInt(pa) !== 2) && <div className="p_modal_todo_icon p_modal_todo_icon--def" />}
                              {(!Boolean(pa) || parseInt(pa) === 2) && parseInt(pa) === 2 && <div className="p_modal_todo_icon p_modal_todo_icon--active" />}
                                <div className="">
                                  <div className="p_modal_todo_name">
                                    Create a game keys package or upload a distributive
                                  </div>
                                  {/* {Boolean(pa) && parseInt(pa) === 2 && <div className="p_modal_todo_desctiption">
                                    Hire an influencer to get players excited about your game
                                  </div>} */}
                                </div>
                              </div>
                          </div>


                          <div className="p_modal_c p_todo_item p_todo_item--inactive">
                            <div className="x_flex">
                              <div className="p_modal_todo_icon p_modal_todo_icon--def" />
                              <div className="p_modal_todo_name">
                                Specify program settings
                              </div>
                            </div>
                            <div className="p_todo_item_active-icon">
                              <div></div>
                            </div>
                          </div>

                          <div className="p_modal_c p_todo_item p_todo_item--inactive">
                            <div className="x_flex">

                              <div className="p_modal_todo_icon p_modal_todo_icon--def" />

                              <div className="p_modal_todo_name">
                                Get a token
                              </div>
                            </div>
                          </div>

                          <div className="p_modal_c p_todo_item p_todo_item--inactive">
                            <div className="x_flex">
                              <div className="p_modal_todo_icon p_modal_todo_icon--def" />
                              <div className="p_modal_todo_name">
                                Sign licensing agreement
                              </div>
                            </div>
                          </div>
                        </div>


                        {/* <div className="p_formgroup_lg p_formgroup_lg--grow">
                          <div className="p_modal_c">
                            <div className="x_flex">
                              <h4 className="p_int_h2">Integration steps</h4>
                            </div>
                          </div>
                          <div className="p_modal_c p_todo_item p_todo_item--inactive">
                            <div className="x_flex">
                              <div className="p_modal_todo_icon p_modal_todo_icon--ok" />
                              <div className="p_modal_todo_name">
                                Connect Xsolla Partner Network
                              </div>
                            </div>
                          </div>
                          <a
                            href="#"
                            className="p_modal_c p_todo_item p_todo_item--active w-inline-block"
                          >
                            <div className="x_flex">
                              <div className="p_modal_todo_icon p_modal_todo_icon--def" />
                              <div className="p_modal_todo_name">
                                Get a token
                              </div>
                            </div>
                          </a>
                          <div className="p_modal_c p_todo_item">
                            <div className="x_flex">
                              <div className="p_modal_todo_icon p_modal_todo_icon--pending" />
                              <div className="p_modal_todo_name">
                                Sign licensing agreement
                              </div>
                            </div>
                          </div>
                          <a
                            href="#"
                            className="p_modal_c p_todo_item w-inline-block"
                          >
                            <div className="x_flex">
                              <div className="p_modal_todo_icon p_modal_todo_icon--def" />
                              <div className="p_modal_todo_name">
                                Go to dashboard
                              </div>
                            </div>
                          </a>
                        </div> */}



                        <div className="x_int_developers">
                          <div className="p_formgroup_lg">
                            <div className="p_modal_c">
                              <div className="x_flex">
                                <h4 className="p_int_h2">
                                  Developer Documentation
                                </h4>
                              </div>
                            </div>
                            <div className="p_modal_c p_todo_item">
                              <div className="x_flex">
                                <div className="p_modal_todo_devicon">
                                  <div>assignment</div>
                                </div>
                                <div className="p_modal_todo_name">
                                  Xsolla Login: authentication methods
                                </div>
                              </div>
                            </div>
                            <div className="p_modal_c p_todo_item">
                              <div className="x_flex">
                                <div className="p_modal_todo_devicon">
                                  <div>assignment</div>
                                </div>
                                <div className="p_modal_todo_name">
                                  MailChimp™ integration
                                </div>
                              </div>
                            </div>
                            <div className="p_modal_c p_todo_item">
                              <div className="x_flex">
                                <div className="p_modal_todo_devicon">
                                  <div>assignment</div>
                                </div>
                                <div className="p_modal_todo_name">
                                  Xsolla Launcher: Build upload
                                </div>
                              </div>
                            </div>
                            <div className="p_modal_c">
                              <a
                                href="http://developer.xsolla.com"
                                target="_blank"
                                className="x_flex x_flex--dev w-inline-block"
                              >
                                <div className="x_int_alldev">
                                  <div className="p_modal_todo_devicon">
                                    <div>open_in_new</div>
                                  </div>
                                  <div className="p_int_devlink">
                                    developer.xsolla.com
                                  </div>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p_formfooter p_formfooter--dash">
                      <div>
                        <div className="p_modal_c">
                          <div className="p_formgroup_xs">
                            <div className="p_comp_int-ctas">
                              <div className="p_x_right p_x_right--moved">
                                <div className="p_x_delegate">
                                  <div className="p_button p_button--appearance-secondary aaa_hover_closest">
                                    <div className="p_button p_button--appearance-flatten p_button--icon">
                                      <div className="p_button_icon w-embed">
                                        <svg
                                          width={20}
                                          height={20}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V8L12 13L20 8V18ZM12 11L4 6H20L12 11Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                    <div>Assign to...</div>
                                  </div>
                                  <div
                                    data-w-id="c948e561-77b0-4491-33b0-70b3491a6391"
                                    className="p_x_assign0"
                                  >
                                    <div className="p_x_assign">
                                      <div className="p_x_assign_li">
                                        <div className="p_0_x_menu-sett p_0_x_menu-sett--big">
                                          <div className="p_button_icon p_0_x_menu-sett--big">
                                            <div className="p_xsollaicon p_xsollaicon--sm">
                                              <div></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="p_0_x_menu-sett">
                                          Contact account manager
                                        </div>
                                      </div>
                                      <div className="p_x_assign_li">
                                        <div className="p_0_x_menu-sett">
                                          <div className="p_button_icon p_0_x_menu-sett--big">
                                            <div className="p_xsollaicon p_xsollaicon--sm">
                                              <div></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="p_0_x_menu-sett">
                                          Assign to co-worker
                                        </div>
                                      </div>
                                      <div className="p_x_assign_li p_x_assign_li--2nd">
                                        <div className="p_x_emailinput w-embed">
                                          <input
                                            className="p_x_emailinput"
                                            placeholder="name@yourcompany.com"
                                            defaultValue
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="p_button p_button--appearance-right">
                                  <div>Finish Later</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="int_b_right">
            <div className="int_iframe0">

                <style
                  dangerouslySetInnerHTML={{
                    __html:
                      "\n#guide-menu {\ndisplay: none !important;\n}\n.all-site-wrap {\ndisplay: block !important;\n}\n",
                  }}
                />

                <Login
                  shown={login}
                  handle={()=>{
                    setLogin()
                    setPa(2)
                  }}
                  hanleClose={()=>{
                    setLogin()
                    setPa()
                  }}
                />


                <iframe
                  className={`int_iframe ${pa && parseInt(pa) === 1 ? 'int_iframe--step-hide' : ''}`}
                  // className="int_doc_ifr"
                  // src="https://developers.xsolla.com/api/v2/store/#api_virtual_items_get_item"
                  src={learnMoreUrl}
                  width="100%"
                ></iframe>
                <iframe
                  className={`int_iframe ${!pa2 ? 'int_iframe--step' : ''}`}
                  // className="int_doc_ifr"
                  // src="https://developers.xsolla.com/api/v2/store/#api_virtual_items_get_item"
                  src={'https://xsolla-business-engine.netlify.app/game_store/new'}
                  width="100%"
                ></iframe>

            </div>
            {/* <IntMarkAsDone/> */}
          </div>

        </section>
        <div className="p_fcard_z shown" />
      </div>
    </CssInt0>
  );
}

export const Integration = withRouter(Integration1);

const CssInt0 = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000000;
`;



export const IntMarkAsDone = () => {
  return (<div className="p_x_doc0">
  <div className="p_x_doc">
    <div className="p_x_doc_b">
      <div className="p_button p_button--appearance-white">
        <div>mark as done</div>
      </div>
      <div className="l_line">
        This step requires you to follow the documentation
      </div>
    </div>
  </div>
</div>)
}